import React, { useEffect, useState } from "react";

export const EstadoSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);

  return (
    <select
      className="select-advertencia"
      name={name} 
      value={value}
      onChange={onChange}
    >
      <option value="CC">Consolidado</option>
      <option value="VG">Vigente</option>
      <option value="VC">Vencido</option>
      {state.map((item) => (
        <option key={`linea-${item.value}`} value={item.value}>
          {item.linea}
        </option>
      ))}
    </select>
  );
};